import VIDABOO_CONSTANTS from '../config/consts';
import PostMessageService from '../services/postMessageService';
import utilsService from '../services/utilsService';
import {AnalyticsEventRestService} from './restServices/restServices';
import storageService from '../services/storageService';
//https://www.lunametrics.com/blog/2016/05/04/integrating-angularjs-google-tag-manager/
var service = {};
// var privateState = {};
service.dataLayer = window.dataLayer || [];
service.apiPush = (obj) => {
  service.dataLayer.push(obj);
};
service.updateUserState = (userObject) => {
  // for drip
  console.debug(userObject);
  if (userObject.email === undefined || userObject.email === null) {
    console.debug('Error 201 in sending data to DCQ');
    return;
  }
  var dcqObject = {};
  for (var key in userObject) {
    if (userObject.hasOwnProperty(key)) {
      if (key !== 'newState' && key !== 'userId') {
        dcqObject[key] = userObject[key];
      } else if (key === 'userId') {
        dcqObject.user_id = userObject.userId;
        dcqObject.consoltoUserId = userObject.userId;
      } else if (key === 'newState') {
        dcqObject.tags = userObject.newState;
      }
    }
  }
  dcqObject.success = function (response) {
    console.debug('DRIP USER ADDED');
    console.debug(response);
    // Call a method with the response object
    // Success callback is optional
  };
  //console.debug (dcqObject);
  if (window._dcq) {
    window._dcq.push(['identify', dcqObject]);
  }
};
service.trackRouteChange = (obj) => {
  service.apiPush({
    event: 'ngRouteChange',
    attributes: {
      route: obj.route,
    },
  });
};
service.trackEvent = (obj) => {
  var attr = obj;
  const arr = ['category', 'action'];
  arr.forEach(function (el) {
    var err;
    if (typeof attr[el] === 'undefined') {
      err = new Error(
        'GTMService.trackEvent: Missing required property ' +
          el +
          '. Aborting hit.',
      );
      throw err;
    }
  });
  service.apiPush({
    event: 'ngTrackEvent',
    attributes: {
      category: attr.category,
      action: attr.action,
      label: attr.label,
      value: attr.value,
      nonInteraction: attr.nonInteraction,
    },
  });

  if (obj.sendToParent === true) {
    var objForParent = {
      category: VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.WIDGET_FOR_PARENT_FRAME,
      action: attr.action,
      label: attr.label,
    };
    PostMessageService.postAnalyticsEvent(objForParent);
  }
};

service.saveConsoltoAnalyticsEvent = (
  analyticsEventDto,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  // console.debug(token ? token : storageService.getItem('token'));
  //   analyticsEventDto.userId =  $rootScope.currentUser.userId;
  //   analyticsEventDto.userRole = $rootScope.currentUser.role;
  analyticsEventDto.senderCreationTime = new Date().getTime();
  analyticsEventDto.error = analyticsEventDto.error === true ? true : false;
  var newRequestObject = {
    token: token ? token : storageService.getItem('token'),
    analyticsEventDto: analyticsEventDto,
  };
  AnalyticsEventRestService.save(
    {
      endpoint: 'save',
    },
    newRequestObject,
    function () {
      if (successCallbackFunction) {
        successCallbackFunction();
      }
    }, // success
    function (response) {
      console.debug(response.data);
      if (failCallbackFunction) {
        failCallbackFunction(response.data);
      }
    },
  ); //   }
};

// service.getCampaign = () => {
//   var campaign = null;
//   if (document.referrer.search("consolto-youtube-revenue-stream") >= 0) {
//     campaign = "youtubers1";
//   } else if (document.referrer.search("bloggers-generate-more-revenue") >= 0) {
//     campaign = "bloggers1";
//   } else if (
//     document.referrer.search(
//       "provide-life-coaching-from-your-own-online-virtual-office"
//     ) >= 0
//   ) {
//     campaign = "life-coaches";
//   } else if (
//     document.referrer.search("legal-advice-from-your-virtual-office") >= 0
//   ) {
//     campaign = "lawyers1";
//   }
//   return campaign;
// };
service.getQueryVariable = (query, variable) => {
  if (query) {
    const vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      if (pair[0] === variable) {
        return pair[1];
      }
    }
  } else return null;
};

service.getMarketingParametersForRegistration = () => {
  if (utilsService.isLocalStorageSupported()) {
    const marketingQueryStr = storageService.getCookie(
      VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS.MARKETING_QUERY,
    );
    let partnerAffiliateInfoId = null;
    let marketingParameterDto = null;
    let marketingParameterAvailable = false;
    if (marketingQueryStr) {
      partnerAffiliateInfoId = service.getQueryVariable(
        marketingQueryStr,
        VIDABOO_CONSTANTS.LOCAL_STORAGE_ITEMS.PARTNER_AFFILIATE_INFO_ID,
      );
      marketingParameterDto = {
        objectType: 'PERSONAL',
        objectId: null,
        marketingCampaignName: partnerAffiliateInfoId
          ? 'affiliateLink'
          : service.getQueryVariable(marketingQueryStr, 'campaign_name'),
        eventName: 'userRegistration',
        utmSource: service.getQueryVariable(marketingQueryStr, 'utm_source'),
        utmMedium: service.getQueryVariable(marketingQueryStr, 'utm_medium'),
        utmCampaign: service.getQueryVariable(
          marketingQueryStr,
          'utm_campaign',
        ),
        utmTerm: service.getQueryVariable(marketingQueryStr, 'utm_term'),
        utmContent: service.getQueryVariable(marketingQueryStr, 'utm_content'),
        referrer: service.getQueryVariable(marketingQueryStr, 'docref'),
        gclid: service.getQueryVariable(marketingQueryStr, 'gclid'),
      };
      marketingParameterAvailable = true;
    } else {
      marketingParameterAvailable = true;
      marketingParameterDto = {
        eventName: 'userRegistration',
        utmSource: 'NA',
        utmMedium: 'NA',
        utmCampaign: 'NA',
        referrer: 'NA',
        gclid: 'NA',
        marketingCampaignName: 'NA',
      };
    }
    return {
      marketingParameterAvailable,
      marketingParameterDto,
      partnerAffiliateInfoId,
    };
  } else {
    return {
      marketingParameterAvailable: true,
      marketingParameterDto: {
        eventName: 'userRegistration',
        utmSource: 'NLSS',
        utmMedium: 'NLSS',
        utmCampaign: 'NLSS',
        referrer: 'NLSS',
        gclid: 'NLSS',

        marketingCampaignName: 'NLSS',
      },
      partnerAffiliateInfoId: null,
    };
  }
};
service.getClientPageViews = (queryObj, successCallbackFunction) => {
  if (queryObj === null || queryObj === undefined) {
    queryObj = {};
  }

  queryObj.endpoint = 'pageViewsByClient';
  //   queryObj.endpointParam = $rootScope.currentUser.userId;
  queryObj.token = storageService.getItem('token');
  AnalyticsEventRestService.save(
    {
      endpoint: 'pageViewsByClient',
    },
    queryObj,

    function (resource) {
      // success
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource);
      }
    },
    function (error) {
      // failure
      utilsService.logApiResponse('getClientPageViews', error);
    },
  );
};

service.getMentorAnalyticsByMentorUserId = (
  queryObj,
  postData,
  successCallbackFunction,
  token,
) => {
  // console.debug("postData here is", postData);
  token = token ? token : storageService.getItem('token');
  if (queryObj === null || queryObj === undefined) {
    queryObj = {};
  }
  queryObj.token = token;
  AnalyticsEventRestService.save(
    {
      endpoint: 'cached/mentorDashboard',
    },
    queryObj,

    function (resource) {
      // success
      // console.debug(resource);
      if (successCallbackFunction) {
        successCallbackFunction(resource);
      }
    },
    function (response) {
      // failure
      console.debug(response);
    },
  );
};

const analyticsService = {...service};
export default analyticsService;
